import { render, staticRenderFns } from "./ContratoDespesaTipo.vue?vue&type=template&id=d7489b1e&"
import script from "./ContratoDespesaTipo.vue?vue&type=script&lang=js&"
export * from "./ContratoDespesaTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports